const PRODUCT_SELECT_EVENT = 'shopify:product:select';

document.addEventListener(PRODUCT_SELECT_EVENT, async (event) => {
  const eventTarget = event.target;
  if (!(eventTarget instanceof Element)) return;

  const productCard = eventTarget.closest('product-card');
  if (!productCard) return;

  const quickAdd = productCard.querySelector('quick-add-component');
  if (!(quickAdd instanceof HTMLElement)) return;

  const optionsCount = Number(quickAdd.dataset.productOptionsCount || 0);

  // Products with more than one option must continue through the selection modal.
  if (optionsCount !== 1) {
    quickAdd.setAttribute('data-quick-add-button', 'choose');
    return;
  }

  try {
    const result = await event.promise;
    const resource = result?.detail?.resource;
    const variantId = resource?.id;
    const isAvailable = resource?.available !== false;

    const variantInput = quickAdd.querySelector('input[name="id"]');
    const addButton = quickAdd.querySelector('.quick-add__button--add');

    if (!variantId || !isAvailable || !(variantInput instanceof HTMLInputElement)) {
      quickAdd.setAttribute('data-quick-add-button', 'choose');
      return;
    }

    // Only show the direct Add button after the selected variant is fully resolved.
    variantInput.value = String(variantId);
    variantInput.disabled = false;

    if (addButton instanceof HTMLButtonElement) {
      addButton.disabled = false;
    }

    quickAdd.setAttribute('data-quick-add-button', 'add');
  } catch (error) {
    quickAdd.setAttribute('data-quick-add-button', 'choose');
    if (error?.name !== 'AbortError') {
      console.warn('[KT Bazar quick add] Variant selection could not be synchronized.', error);
    }
  }
});
